// Please keep in sync with AppsForOfficeSingleSignOnErrorCode in devmain
export enum SsoErrorCode {
    Success = 0,

    OperationNotSupported = 5000,

    InternalError = 5001,

    BrowserAPINotSupported = 5009,

    CrossZone = 12011,

    NotSsoAgave = 13000,

    UserNotSignedIn = 13001,

    UserAborted = 13002,

    UnsupportedUserIdentity = 13003,

    InvalidResourceUrl = 13004,

    InvalidGrant = 13005,

    ClientError = 13006,

    ServerError = 13007,

    AddinIsAlreadyRequestingToken = 13008,
}
